export default "__VITE_ASSET__DVFwmSQI__"